import {assert} from 'assert-ts';
import type {ThesaurusAction} from 'types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import {useSceneExtensionContext} from 'sceneExtensions/contexts';
import type {MultiThesaurusFieldConfig, MultiThesaurusValue} from '../types';

export const useMultiThesaurusEditContext = () => {
  const extension = useSceneExtensionContext<
    FieldExtensionEnum.multiThesaurusEdit,
    MultiThesaurusValue,
    MultiThesaurusValue,
    ThesaurusAction,
    MultiThesaurusFieldConfig
  >(FieldExtensionEnum.multiThesaurusEdit);
  return assert(extension).fieldContext;
};
